module.exports = __webpack_public_path__ + "img/pp.5a947093.png";